export default __webpack_public_path__ + "static/avatar-0e83341ae328a4d84dcc7c602cb6bc7b.webp";